<template>
    <a :href="item.url" class="search__dropdown-item" @click="runEvent()" :style="{ opacity: item.opacity || 1 }" target="_blank">
        <span v-html="item.name"></span>
        <sup v-if="item.status == 0" class="small">Выключено</sup>

        <span v-if="item.detail">
            <sup v-if="item.detail.partner" class="small" :class="getPartnerClass()" v-text="item.detail.partner"></sup>
            <sup v-if="item.detail.vip" class="small color-green">VIP</sup>
            <sup v-if="item.detail.is_closed > 0" class="small">Закрыто</sup>

            <span v-if="item.detail.renamed_to" v-html="` (новое название ${item.detail.renamed_to})`" class="search__dropdown-item-detail small"></span>
            <span v-html="item.detail.address" class="search__dropdown-item-detail font-italic"></span>
        </span>
    </a>
</template>

<script>
    export default {
        props: {
            item: {
                type: Object,
                required: true
            }
        },

        methods: {
            runEvent() {
                $app.runEvent('click', { 'главный поиск': this.item.name })
            },

            getPartnerClass() {
                return this.item.detail.partner === 'gdebar' ? 'color-orange' : 'color-blue'
            }
        }
    }
</script>